exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width : 992px) {\n  .pad-left{\n    padding: 0 0 0 10px;\n  }\n}\n\n.form-group{\n\tmargin-bottom: 30px;\n}\n\n.main-login{\n \tbackground-color: #fff;\n  /* shadows and rounded borders */\n  border-radius: 2px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.main-center{\n  margin-top: 50px;\n  padding: 50px 50px 10px 50px;\n}\n\n.btn.btn-signin {\n  margin: auto;\n  max-width: 150px;\n  background-color: rgb(31,64,10);\n  padding: 0px;\n  font-weight: 700;\n  font-size: 14px;\n  height: 36px;\n  border-radius: 3px;\n  border: none;\n  transition: all 0.218s;\n}\n\n.btn.btn-signin:hover,\n.btn.btn-signin:active,\n.btn.btn-signin:focus {\n    background-color: rgb(78,39,24);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/sign-up/sign-up.component.css
// module id = ../../../../../src/app/sign-up/sign-up.component.css
// module chunks = main